import React, { useState, useRef, useEffect } from "react";
import { dashboardColors, theme } from "../../../../themes/Theme";
import { clickOutside } from "../../../../reusable/common";

const FilterDropdown = ({
  options,
  value,
  onChange,
  onCustomSelect,
  className = "",
  placeholder = "Select...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);


  clickOutside(dropdownRef, () => setIsOpen(false));

  const selectedOption = options?.find((opt) => opt?.value === value);

  const handleSelect = (option) => {
    if (option.value === "custom") {
      onCustomSelect && onCustomSelect();
    } else {
      onChange(option);
    }
    setIsOpen(false);
  };

  return (
    <div className={`report-custom-dropdown ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className={`report-dropdown-button ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="report-dropdown-text">
          {selectedOption ? selectedOption?.label : placeholder}
        </span>
        <svg
          className={`report-dropdown-icon ${isOpen ? "rotated" : ""}`}
          width="14"
          height="14"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="report-dropdown-menu-container">
          <ul className="report-dropdown-options">
            {options?.map((option) => (
              <li
                key={option?.value}
                className={`report-dropdown-option ${value === option?.value ? "selected" : ""}`}
                onClick={() => handleSelect(option)}
              >
                {option?.label}
                {value === option?.value && <span className="report-dropdown-checkmark">✓</span>}
              </li>
            ))}
          </ul>
        </div>
      )}

      <style jsx>{`
        .report-custom-dropdown {
          position: relative;
          display: inline-block;
        }

        .report-dropdown-button {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 12px;
          background: white;
          border: 0.5px solid #C3CDDF;
          border-radius: 2px;
          cursor: pointer;
          min-width: 130px;
          font-size: 14px;
          font-weight: 400;
          color: #374151;
          transition: all 0.2s ease;
          outline: none;
        }


        .report-dropdown-button.open {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .report-dropdown-text {
          flex: 1;
          text-align: left;
        }

        .report-dropdown-icon {
          margin-left: 8px;
          color: #1e1f24;
          transition: transform 0.2s ease;
        }

        .report-dropdown-icon.rotated {
          transform: rotate(180deg);
        }

        .report-dropdown-menu-container {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          z-index: 1000;
          margin-top: 4px;
        }

        .report-dropdown-options {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          margin: 0;
          padding: 4px 0;
          list-style: none;
        }

        .report-dropdown-option {
          padding: 8px 12px;
          font-size: 14px;
          color: #374151;
          cursor: pointer;
          transition: background-color 0.15s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .report-dropdown-option:hover {
          background-color: #f9fafb;
        }

        .report-dropdown-option.selected {
          background-color: #eff6ff;
          color: #3b82f6;
          font-weight: 500;
        }

        .report-dropdown-checkmark {
          color: #3b82f6;
          font-weight: bold;
        }
         .report-dropdown-button {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 12px;
            background: white;
            cursor: pointer;
            min-width: 130px;
            font-size: 14px;
            font-weight: 500;
            color: ${dashboardColors[theme].primary};
            transition: all 0.2s ease;
            outline: none;
          }


          .report-dropdown-button.open {
            //border-color: #3b82f6;
            //box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .report-dropdown-text {
            flex: 1;
            text-align: left;
          }

          .report-dropdown-icon {
            margin-left: 8px;
            color: #1e1f24;
            transition: transform 0.2s ease;
          }

          .report-dropdown-icon.rotated {
            transform: rotate(180deg);
          }

          .report-dropdown-menu-container {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            z-index: 1000;
            margin-top: 4px;
          }

          .report-dropdown-options {
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
            margin: 0;
            padding: 4px 0;
            list-style: none;
            border-radius: 2px;
          }

          .report-dropdown-option {
            padding: 8px 12px;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            transition: background-color 0.15s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .report-dropdown-option:hover {
            background-color: #f9fafb;
          }

          .report-dropdown-option.selected {
            background-color: #eff6ff;
            color: ${dashboardColors[theme].primaryTextColor};
            font-weight: 500;
          }

          .report-dropdown-checkmark {
            color: ${dashboardColors[theme].primary};
            font-weight: bold;
          }
      `}</style>
    </div>
  );
};

export default FilterDropdown;
